import { createSlice } from "@reduxjs/toolkit";
import { BusinessDetailsData } from "../types/VerBusinessDetailsType";
import { getCorrBank } from "../action/getCorrBank";

const initialState: BusinessDetailsData = {
  data: null,
  loading: false,
  error: null,
  successfull: false,
};

const verCorrBankDetailsSlice = createSlice({
  name: "verCorrBankDetailsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCorrBank.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCorrBank.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // // console.log("DATA createAppSlice", action);
      })
      .addCase(getCorrBank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const verCorrBankDetailsReducer = verCorrBankDetailsSlice.reducer;
